import { useState, useEffect } from 'react'
import { router, usePage } from '@inertiajs/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars, faXmark, faGauge, faRightFromBracket } from '@fortawesome/free-solid-svg-icons'
import { NAV_LINKS, resolvePublicHref } from '../constants/navLinks'
import logo from '../../assets/images/logo-nav-foo-bar.png'

export default function Navbar() {
  const { current_user } = usePage().props
  const pageUrl = usePage().url
  const isHomePage = pageUrl === '/'
  const logout = () => { if (confirm('Yakin ingin keluar?')) router.delete('/logout') }
  const [scrolled, setScrolled] = useState(false)
  const [mobileOpen, setMobileOpen] = useState(false)

  // Homepage hero is dark — transparent nav with light text.
  // Other public pages start on white/light bg — use solid nav immediately.
  const lightNav = scrolled || !isHomePage

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20)
    onScroll()
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <nav className={`fixed top-0 z-50 w-full transition-all duration-300 ${lightNav ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-18">

          {/* Logo */}
          <a href="/" className="flex items-center gap-3">
            <img src={logo} className="h-9 w-auto" alt="WBS Kalsel" />
            <div className="leading-tight">
              <span className={`font-bold text-lg tracking-tight ${lightNav ? 'text-slate-900' : 'text-white'}`}>WBS</span>
              <span className={`block text-xs font-medium ${lightNav ? 'text-slate-500' : 'text-blue-200'}`}>Pemprov Kalsel</span>
            </div>
          </a>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center gap-8">
            {NAV_LINKS.map(link => (
              <a key={link.href} href={resolvePublicHref(link.href, isHomePage)}
                className={`text-sm font-medium transition-colors ${lightNav ? 'text-slate-600 hover:text-blue-600' : 'text-blue-100 hover:text-white'}`}>
                {link.label}
              </a>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            {!current_user ? (
              <>
                <a href="/cek-laporan"
                  className={`text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-blue-200 text-blue-700 hover:bg-blue-50' : 'border-blue-300 text-blue-100 hover:bg-white/10'}`}>
                  Cek Laporan
                </a>
                <a href="/login"
                  className={`text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-slate-300 text-slate-700 hover:bg-slate-50' : 'border-white/40 text-white hover:bg-white/10'}`}>
                  Masuk
                </a>
                <a href="/register"
                  className="text-sm font-semibold px-5 py-2 bg-blue-600 hover:bg-blue-500 text-white rounded-lg transition-colors shadow-md shadow-blue-900/20">
                  Daftar
                </a>
              </>
            ) : current_user.superadmin ? (
              <>
                <a href="/superadmin/dashboard"
                  className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-purple-200 text-purple-700 hover:bg-purple-50' : 'border-purple-300 text-purple-100 hover:bg-white/10'}`}>
                  <FontAwesomeIcon icon={faGauge} className="w-3.5 h-3.5" />
                  Panel Superadmin
                </a>
                <button onClick={logout}
                  className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-slate-300 text-slate-700 hover:bg-slate-50' : 'border-white/40 text-white hover:bg-white/10'}`}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="w-3.5 h-3.5" />
                  Keluar
                </button>
              </>
            ) : current_user.admin ? (
              <>
                <a href="/admin/dashboard"
                  className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-blue-200 text-blue-700 hover:bg-blue-50' : 'border-blue-300 text-blue-100 hover:bg-white/10'}`}>
                  <FontAwesomeIcon icon={faGauge} className="w-3.5 h-3.5" />
                  Panel Admin
                </a>
                <button onClick={logout}
                  className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-slate-300 text-slate-700 hover:bg-slate-50' : 'border-white/40 text-white hover:bg-white/10'}`}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="w-3.5 h-3.5" />
                  Keluar
                </button>
              </>
            ) : (
              <>
                <a href="/cek-laporan"
                  className={`text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-blue-200 text-blue-700 hover:bg-blue-50' : 'border-blue-300 text-blue-100 hover:bg-white/10'}`}>
                  Cek Laporan
                </a>
                <a href="/user/dashboard"
                  className={`flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-lg border transition-colors ${lightNav ? 'border-green-200 text-green-700 hover:bg-green-50' : 'border-green-300 text-green-100 hover:bg-white/10'}`}>
                  <FontAwesomeIcon icon={faGauge} className="w-3.5 h-3.5" />
                  Dashboard
                </a>
                <button onClick={logout}
                  className={`flex items-center gap-2 text-sm font-semibold px-5 py-2 bg-green-600 hover:bg-green-500 text-white rounded-lg transition-colors shadow-md shadow-green-900/20`}>
                  <FontAwesomeIcon icon={faRightFromBracket} className="w-3.5 h-3.5" />
                  Keluar
                </button>
              </>
            )}
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
            className={`md:hidden p-2 rounded-lg ${lightNav ? 'text-slate-700' : 'text-white'}`}
          >
            <FontAwesomeIcon icon={mobileOpen ? faXmark : faBars} className="w-6 h-6" />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-slate-100 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            {NAV_LINKS.map(link => (
              <a
                key={link.href}
                href={resolvePublicHref(link.href, isHomePage)}
                onClick={() => setMobileOpen(false)}
                className="block px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-slate-50 rounded-lg"
              >
                {link.label}
              </a>
            ))}
            <div className="pt-3 border-t border-slate-100 flex flex-col gap-2">
              {!current_user ? (
                <>
                  <a href="/cek-laporan" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-blue-200 text-blue-700 rounded-lg">
                    Cek Laporan
                  </a>
                  <a href="/login" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-slate-300 text-slate-700 rounded-lg">
                    Masuk
                  </a>
                  <a href="/register" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-semibold bg-blue-600 text-white rounded-lg">
                    Daftar
                  </a>
                </>
              ) : current_user.superadmin ? (
                <>
                  <a href="/superadmin/dashboard" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-purple-200 text-purple-700 rounded-lg">
                    Panel Superadmin
                  </a>
                  <button onClick={() => { setMobileOpen(false); logout() }}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-slate-300 text-slate-700 rounded-lg">
                    Keluar
                  </button>
                </>
              ) : current_user.admin ? (
                <>
                  <a href="/admin/dashboard" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-blue-200 text-blue-700 rounded-lg">
                    Panel Admin
                  </a>
                  <button onClick={() => { setMobileOpen(false); logout() }}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-slate-300 text-slate-700 rounded-lg">
                    Keluar
                  </button>
                </>
              ) : (
                <>
                  <a href="/cek-laporan" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-blue-200 text-blue-700 rounded-lg">
                    Cek Laporan
                  </a>
                  <a href="/user/dashboard" onClick={() => setMobileOpen(false)}
                    className="text-center px-4 py-2.5 text-sm font-medium border border-green-200 text-green-700 rounded-lg">
                    Dashboard
                  </a>
                  <button onClick={() => { setMobileOpen(false); logout() }}
                    className="text-center px-4 py-2.5 text-sm font-semibold bg-green-600 text-white rounded-lg">
                    Keluar
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </nav>
  )
}
